import { createFeatureSelector, createSelector } from '@ngrx/store';
import { sharedFeatureKey } from 'src/app/shared/selectors';
import { SharedState } from 'src/app/shared/state/shared.state';

export const sharedFeature = createFeatureSelector<SharedState>(sharedFeatureKey);

export const getStates = createSelector(sharedFeature, (state) => state.states.states);
